import store from '../store';

export default {
    parseStatus(id){
        if(id===-1) return "Voided"
        else if(id===0) return "Draft"
        else if(id===1) return "Sealed"
        else if(id===2) return "Admin Sealed"
        else if(id===3) return "Delivery Scheduled"
        else if(id===4) return "Pending Reschedule"
        else if(id===5) return "Out For Delivery"
        else if(id===6) return "Delivered"
    },
    getStatusColor(s){
        let color = 'grey'
        if(s===-1) color = 'warning'
        if(s===0) color = 'info'
        if(s===1) color = 'success'
        return color
    },
    getHPStatusColor(s){
        let color = 'grey'
        if(s===-1) color = 'warning'
        if(s===0) color = 'info'
        if(s===1) color = 'success'
        if(s===2) color = 'lime'
        if(s===3) color = 'error'
        return color
    },
    parseHPStatus(id){
        if(id===-1) return "Voided"
        else if(id===0) return "Draft"
        else if(id===1) return "Sealed"
        else if(id===2) return "Active"
        else if(id===3) return "Closed"
        else if(id===4) return "Reposessed"
    },
    getStocktakingEventStatusColor(s){
        let color = 'grey'
        if(s===-1) color = 'warning'
        if(s===0) color = 'info'
        if(s===1) color = 'success'
        if(s===2) color = 'purple'
        if(s===3) color = 'primary'
        if(s===4) color = 'grey'
        return color
    },
    parseStocktakingEventStatus(id){
        if(id===-1) return "Voided"
        else if(id===0) return "New"
        else if(id===1) return "In-progress"
        else if(id===2) return "Stopped"
        else if(id===3) return "Paused"
        else if(id===4) return "Ended"
    },
    parseCNStatus(id){
        if(id===-1) return "Voided"
        else if(id===1) return "Unredeemed"
        else if(id===2) return "Redeemed"
    },
    parsePOStatus(id){
        if(id===-1) return "Voided"
        else if(id===0) return "Draft"
        else if(id===1) return "Sealed"
        else if(id===2) return "Fulfilled"
    },
    getPOStatusColor(s){
        let color = 'grey'
        if(s===-1) color = 'warning'
        if(s===0) color = 'info'
        if(s===1) color = 'success'
        return color
    },
    parseRRStatus(id){
        if(id===-1) return "Voided"
        else if(id===0) return "Draft"
        else if(id===1) return "Sealed"
    },
    getRRStatusColor(s){
        let color = 'grey'
        if(s===-1) color = 'warning'
        if(s===0) color = 'info'
        if(s===1) color = 'success'
        return color
    },
    parseITStatus(id){
        if(id===-1) return "Voided"
        else if(id===0) return "Draft"
        else if(id===1) return "Sent Out"
        else if(id===2) return "Received"
    },
    getITStatusColor(s){
        let color = 'grey'
        if(s===-1) color = 'warning'
        if(s===0) color = 'info'
        if(s===1) color = 'secondary'
        if(s===2) color = 'success'
        return color
    },
    parseDeliveryStatus(id){
        if(id===-1) return "Voided"
        else if(!id) return "No Scheduled Dispatches"
        else if(id===1) return "In Progress"
        else if(id===2) return "Completed"
        else return "N/A"
    },
    getDeliveryStatusColor(s){
        let color = 'info'
        if(s===-1) color = 'warning'
        if(s===0) color = 'info'
        if(s===1) color = 'teal accent-3'
        if(s===2) color = 'success'
        return color
    },
    parseDispatchStatus(id){
        if(id===-1) return "Voided"
        else if(id===0) return "New"
        else if(id===1) return "Scheduled"
        else if(id===2) return "Out for Delivery"
        else if(id===3) return "Attempted Delivery"
        else if(id===4) return "Delayed"
        else if(id===5) return "Delivered"
        else return "Other"
    },
    getDispatchStatusColor(s){
        let color = 'info'
        if(s===-1) color = 'warning'
        if(s===0) color = 'info'
        if(s===1) color = 'cyan darken-1'
        if(s===2) color = 'teal darken-1'
        if(s===3) color = 'lime darken-1'
        if(s===4) color = 'red darken-1'
        if(s===5) color = 'success'
        return color
    },
    formatDate(d, type="short"){
        if(!d) return "None";
        if(d==0) return "None";
        if(type=="short")
            return (new Date(d)).toLocaleDateString('en-TT')
        if(type=="long")
            return (new Date(d)).toLocaleDateString('en-TT', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
        if(type=="withTime")
            return (new Date(d)).toLocaleDateString('en-TT') + ' ' + this.formatTime(d)
    },
    formatTime(t){
        if(!t) return "None";
        return (new Date(t).toLocaleTimeString('en-TT'))
    },
    formatCurrency(value){
        if(value===null || value===undefined || isNaN(value)) return "";
        let formatter = new Intl.NumberFormat('en-TT', {
          style: 'currency',
          currency: 'TTD'
        });
        return formatter.format(this.pff2(value));
    },
    parseDate(date, type){
        if(!date){
            return ""
        }
        switch (type) {
            default:
                return new Date(date).toISOString().substring(0, 10);
            case 1:
                return new Date(date).toISOString().replace(/-/g, '/').replace(/T.+/, '')
            case 2:
                return new Date(new Date(date).toISOString().replace(/-/g, '/').replace(/T.+/, '')).toDateString()
            case 3:
                return new Date(new Date(date)).toLocaleString();
        }
    },
    parseOrderStatus(id){
        if(id===-1) return "Voided"
        else if(id===0) return "Draft"
        else if(id===1) return "Sealed"
        else if(id===2) return "Admin Sealed"
        else if(id===3) return "Delivery Scheduled"
        else if(id===4) return "Pending Reschedule"
        else if(id===5) return "Out For Delivery"
        else if(id===6) return "Delivered"
    },
    openInNewTab(router, link, external=false){
        let route;
        if(!link) return;
        if(!external) route = router.resolve({ path: link });
        window.open(external?link:route.href, "_blank")
    },
    pff2(val) {
        // round half away from zero to cents. toPrecision(15) strips float noise (1.005 * 100 = 100.49999999999999 still gives 1.01)
        // without the old "round to 3 decimals, then to 2" double rounding that turned 907.8947 into 907.90.
        const n = parseFloat(val);
        if (!Number.isFinite(n)) return NaN;
        const x = parseFloat((Math.abs(n) * 100).toPrecision(15));
        return ((Math.sign(n) * Math.round(x)) || 0) / 100;
    },
    daysBetween(first,second) {
        return Math.round((second - first) / (1000 * 60 * 60 * 24))
    },
    pff(val, n){
        if(!n){
            let v = store.getters.getGlobalValue("quantityPrecision");
            n = parseInt(v || "0")
        }

        return parseFloat(parseFloat(val).toFixed(n))
    },
    // precision overrides the global quantityPrecision (unit conversion lines pass 6 so 4in = 0.333333ft stays exact).
    computeMultipleQuantity(qtyOfMultiple, multipleAmount, precision){
        // The multiple can be a converted amount like 4in = 0.333333ft, so only the final quantity is rounded.
        return this.pff(this.pff(qtyOfMultiple||0, 6) * this.pff(multipleAmount||0, 12), precision)
    },
    // The quantity a line is priced on, in price units (e.g. 52 in is 5 ft when rounding up) while inventory stays in the base unit.
    billableQuantity(item){
        let conv = item.metadata && item.metadata.conversion;
        if(!conv) return this.pff(item.quantity);
        if(conv.roundPerUnit && conv.roundUp && conv.priceUnit){
            // each multiple is rounded up on its own, then multiplied: 10ft 2in x 5 -> 11ft x 5 = 55ft
            let multiples = (item.metadata.quantities && item.metadata.quantities.length > 0)
                ? item.metadata.quantities.reduce((a, l) => a + (parseFloat(l.qtyOfMultiple) || 0), 0)
                : (parseFloat(item.metadata.qtyOfMultiple) || 0);
            return this.pff(Math.ceil(this.pff(parseFloat(item.metadata.multipleAmount) / (conv.priceFactor || 1), 9)) * multiples, 9);
        }
        let q = this.pff(parseFloat(item.quantity) / (conv.priceFactor || 1), 9);
        return (conv.roundUp && conv.priceUnit) ? Math.ceil(q) : q
    },
    // Unit conversions: each field converts to the base unit as value * num / den.
    // New lines start on the field defaults; if that adds up to nothing the first field starts at 1 so the line has a quantity.
    newConversionState(conv, roundUp, roundPerUnit){
        let values = {};
        for(let f of conv.fields) values[f.label] = f.default ?? f.min ?? 0;
        let state = {id: conv.id, unit: conv.unit, fields: conv.fields, values, priceUnit: conv.priceUnit || null, priceFactor: conv.priceFactor || 1, roundUp: !!conv.priceUnit && conv.priceUnit !== conv.unit && roundUp !== false, roundPerUnit: !!roundPerUnit};
        if(this.conversionAmount(state) <= 0) state.values[conv.fields[0].label] = Math.max(conv.fields[0].min || 0, 1);
        return state;
    },
    // Splits a base unit quantity into the conversion's fields, largest first, e.g. 38 in -> "3ft 2in".
    conversionBreakdown(conversion, quantity){
        let rest = Math.round(parseFloat(quantity) * 1e6) / 1e6;
        if(!Number.isFinite(rest) || rest === 0) return '';
        if(rest < 0) return '-' + this.conversionBreakdown(conversion, -rest);
        let fields = [...conversion.fields].sort((a, b) => (b.num / b.den) - (a.num / a.den));
        let parts = [];
        for(let f of fields){
            let factor = f.num / f.den;
            let n = Math.floor(Math.round(rest / factor * 1e6) / 1e6);
            if(n > 0){
                parts.push(`${n}${f.label}`);
                rest = Math.round((rest - n * factor) * 1e6) / 1e6;
            }
        }
        if(rest > 0) parts.push(`${rest}${conversion.unit}`);
        return parts.join(' ');
    },
    conversionAmount(conversion){
        let total = 0;
        for(let f of conversion.fields) total += (parseFloat(conversion.values[f.label]) || 0) * f.num / f.den;
        return this.pff(total, 12);
    },
    multipleLabelOf(meta, productMeta){
        let label = (meta && meta.multipleLabel!=null ? meta.multipleLabel : (productMeta && productMeta.multipleLabel));
        label = (label||'').toString().trim();
        return label || 'Multiple';
    },
    isUsedInMultiples(meta){
        return !!(meta && meta.qtyOfMultiple!=null && meta.multipleAmount!=null);
    },
    getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    },

    /**
     * Adjusts a number to the specified digit.
     *
     * @param {"round" | "floor" | "ceil"} type The type of adjustment.
     * @param {number} value The number.
     * @param {number} exp The exponent (the 10 logarithm of the adjustment base).
     * @returns {number} The adjusted value.
     */
    decimalAdjust(type, value, exp) {
        type = String(type);
        if (!["round", "floor", "ceil"].includes(type)) {
            throw new TypeError(
                "The type of decimal adjustment must be one of 'round', 'floor', or 'ceil'.",
            );
        }
        exp = Number(exp);
        value = Number(value);
        if (exp % 1 !== 0 || Number.isNaN(value)) {
            return NaN;
        } else if (exp === 0) {
            return Math[type](value);
        }
        const [magnitude, exponent = 0] = value.toString().split("e");
        const adjustedValue = Math[type](`${magnitude}e${exponent - exp}`);
        // Shift back
        const [newMagnitude, newExponent = 0] = adjustedValue.toString().split("e");
        return Number(`${newMagnitude}e${+newExponent + exp}`);
    },

    getMobileOperatingSystem() {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "unknown";
    },

    // Normalizes the many shapes an "error" can take across this app (a plain string,
    // res.data.error as a string or {msg} object, a thrown JS Error, an Axios error) into
    // a single displayable message for the snackbar.
    extractErrorMessage(error){
        if(!error) return "An unexpected error occurred."
        if(typeof error === 'string') return error
        if(error.response && error.response.data && error.response.data.error){
            return this.extractErrorMessage(error.response.data.error)
        }
        if(error.msg){
            if(typeof error.msg === 'string') return error.msg
            if(error.msg.message) return error.msg.message
        }
        if(error.message) return error.message
        if(error.error) return this.extractErrorMessage(error.error)
        try {
            return JSON.stringify(error)
        } catch(e) {
            return String(error)
        }
    },

    objectAlphaSort(arr, field, asc=true){
        let newArr = [...arr];

        newArr.sort((a, b) => {
            if(!isNaN(a[field]) && !isNaN(b[field])) return asc?a[field]-b[field]:b[field]-a[field];
            const nameA = a[field].toUpperCase();
            const nameB = b[field].toUpperCase();
            if (nameA < nameB) {return asc?-1:1;}
            if (nameA > nameB) {return asc?1:-1;}
            return 0;
        })

        return newArr;
    }
}